import {LinkedList} from '@/utils/LinkedList/LinkedList';
import {LinkedListNode} from '@/utils/LinkedList/LinkedListNode';

import {Store} from '../Store';

export interface OnboardingState {
  step: LinkedListNode<string> | null;
  onboardingSteps: LinkedList<string> | null;
}

export class OnboardingStore extends Store<OnboardingState> {
  constructor() {
    super({
      step: null,
      onboardingSteps: new LinkedList(),
    });
  }

  public setOnboardingStepList(stepList: string[], initialStep: string): void {
    this.setValue('onboardingSteps', LinkedList.fromArray(stepList));

    const currentStepNode = this.getStep(initialStep);

    if (currentStepNode) {
      this.setValue('step', currentStepNode);
    }
  }

  public getOnboardingStep = (): string | undefined => {
    return this.state.step?.getValue();
  };

  public isCurrentStep(id: string): boolean {
    return this.getOnboardingStep() === id;
  }

  // толкает онбординг и возвращает индекс следующего шага
  public nextStep = (): number => {
    const step = this.state.step?.getNext() || null;
    this.setValue('step', step);
    return step ? this.getStepIndex(step?.getValue()) : -1;
  };

  public finishOnboarding(): void {
    this.setState({
      step: null,
      onboardingSteps: new LinkedList(),
    });
  }

  // вернет true, если переданный шаг из онбординга еще не показан
  public isStepAfterViewed(id: string): boolean {
    if (!this.state.onboardingSteps) return false;

    const currentStep = this.getOnboardingStep();
    if (currentStep === null || currentStep === undefined) return false;

    const currentIndex = this.getStepIndex(currentStep);
    if (currentIndex === -1) return false;

    const nodeIndex = this.getStepIndex(id);
    if (nodeIndex === -1) return false;

    return currentIndex < nodeIndex;
  }

  private getStepIndex(id: string): number {
    const index = this.state.onboardingSteps?.findIndex((node) => node.getValue() === id);
    return index === undefined ? -1 : index;
  }

  private getStep(id: string): LinkedListNode<string> | undefined {
    return this.state.onboardingSteps?.find((node) => node.getValue() === id);
  }
}
